import { makeSelector } from 'containers/app/selectors'

const profilePictures = (state) => state.getIn(['results', 'profilePictures'])
const activeByIndex = (state) => state.getIn(['results', 'activeByIndex'])
const showSearchResults = (state) =>
  state.getIn(['results', 'showSearchResults'])
const selectedColleagues = (state) =>
  state.getIn(['results', 'getSelectedColleagues'])

export const getProfilePictures = makeSelector(profilePictures)
export const getActiveByIndex = makeSelector(activeByIndex)
export const getShowSearchResults = makeSelector(showSearchResults)
export const getSelectedColleagues = makeSelector(selectedColleagues)
